import helpers from "../helpers";
import MicroModal from "micromodal";

export default function modalInit() {
	MicroModal.init({
		openTrigger: "data-modal-open",
		closeTrigger: "data-modal-close",
		disableFocus: true,
		onShow: (modal) => {
			helpers.lockScroll(true, helpers.$header, "header");
		}, // [1]
		onClose: (modal) => {
			helpers.lockScroll(false, helpers.$header, "header");
		}, // [2]
	});

	$("#modal-success [data-modal-close]").on("click", (e) => {
		MicroModal.close("modal-success");
	});
}
